import ProgressiveHorizontalArrows from "@/components/ProgressiveHorizontalArrows";
import ProgressiveVerticalArrow from "@/components/ProgressiveVerticalArrow";
import { ModuleCommandEnum } from "@/types/enums/module-command.enum";

export const SwitchAnimatedArrowRender = ({
  command,
}: {
  command: ModuleCommandEnum;
}) => {
  switch (command) {
    case ModuleCommandEnum.UP:
      return <ProgressiveVerticalArrow direction="up" tw="h-full w-auto" />;
    case ModuleCommandEnum.DOWN:
      return <ProgressiveVerticalArrow direction="down" tw="h-full w-auto" />;
    case ModuleCommandEnum.CLOSE:
      return (
        <ProgressiveHorizontalArrows mode="convergent" tw="h-full w-auto" />
      );
    case ModuleCommandEnum.OPEN:
      return (
        <ProgressiveHorizontalArrows mode="divergent" tw="h-full w-auto" />
      );
  }
};
